import R from 'ramda'

export const toApi = (query, state) => {
  const {viewPort} = state
  const [services, pois] = R.partition((p) => !!p.type, query.pois)
  const areaOption = R.find(R.propEq('name', state.areaUnit), state.options.areaUnits)
  const areaConvert = areaOption.toMeter

  return   {
    viewPort: viewPort,
    features: {
      rental: query.features.rental,
      areas: {
        min: areaConvert(query.features.areas.min),
        max: areaConvert(query.features.areas.max),
      },
      prices: query.features.prices,
    },
    estatesTypes: query.features.estateTypes,
    options: {
      bathRooms: query.options.bathrooms,
      garage: query.options.garage,
      garden: query.options.garden,
      likedOnly: query.options.likedOnly,
      newOnly: query.options.newOnly,
      rooms: query.options.rooms,
      swimmingPool: query.options.swimmingPool,
      terrace: query.options.terrace
    },
    services: R.map( service => ({
      serviceId: service.type,
      transporationDuration: service.travelDuration * 60,
      transportationType: service.transportationType,
    }), services),
    pois: R.map(poiToApi, pois),
    provinces: query.provinces,
    regions: query.regions,
    towns: query.towns,
  }
}

export const poiToApi = (poi) => ({
  description: poi.description,
  coordinates: poi.coordinates,
  distance: poi.travelDuration * 60,
  transportationType: poi.transportationType,
  arrivalTime: poi.arrivalTime,
  departureTime: poi.departureTime,
  daysInWeek: poi.frequency,
})

export const poiFromApi = (queryPoi, index) => ({
  description: queryPoi.description,
  coordinates: queryPoi.coordinates,
  travelDuration: queryPoi.distance / 60,
  transportationType: queryPoi.transportationType,
  arrivalTime: queryPoi.arrivalTime,
  departureTime: queryPoi.departureTime,
  frequency: queryPoi.daysInWeek,
  type: "",
  isOpen: true,
  markerCount: index
})

export const serviceFromApi = (service, suggestions) => {
    var suggestionService = R.find(R.propEq('type', service.serviceId), suggestions)
        
    return { 
        type: service.serviceId,
        description: !!suggestionService ? suggestionService.name : service.serviceId,
        transporationDuration: service.travelDuration / 60,
        transportationType: service.transportationType,
    }
}


export const fromApi = (query, suggestions) => {
    
  var pois = [];
  if (query.pois && query.pois.length > 0)
  {
     for(var i=0; i<query.pois.length; i++) {
         pois.push(poiFromApi(query.pois[i], i + 1));
     }   
  }
  
  if (query.services && query.services.length > 0)
  {
     for(var i=0; i<query.services.length; i++) {
         pois.push(serviceFromApi(query.services[i], suggestions));
     }   
  }
    
  return {
    features: {
      rental: query.features.rental,
      areas: query.features.area,
      prices: query.features.prices,
      estateTypes: query.estatesTypes,
    },
    options: query.options,
    pois: pois,
    provinces: query.provinces,
    regions: query.regions,
    towns: query.towns,
  }
}



/** WEBPACK FOOTER **
 ** ./app/utils/apiMapper.js
 **/